export default {
  qstudio: {
    title: '简介',
    titleP1_1:`
    Q-Studio是一款原子尺度的材料建模应用，主要用于辅助用户进行第一性原理计算前的晶体结构准备工作，与云平台应用
    `,
    titleP1_2:`
    配合，可以完成从材料建模到性质模拟的一整套流程。目前，Q-Studio V1.0版本已于2022年4月正式登陆
    `,
    titleP1_3:`
    ，已注册用户可以直接点击Q-Studio图标打开应用，开始材料建模工作。
    `,
    feature1: `
    Q-Studio基于开源软件Jmol开发，在原有基础上完善了晶体结构的展示及建模功能。
    目前具有的主要功能有建立晶格、本地结构导入（支持pwmat、cif、vasp格式）、
    结构导出（支持pwmat、cif格式）、修改晶格常数、建立超胞、添加删除原子、
    修改元素、移动原子、对称性限制下的拖拽原子、建立超胞、测量距离/角度/二面角。
    `,
    feature2: `
    使用Q-Studio建模时，可以直接选中部分原子并建立群组，方便在后续建模操作中重新选中群组内原子，如小分子、团簇等。
    `,
    feature3: `
    Q-Studio作为前处理应用，可以直接选中原子进行固定或设置初始磁矩，从而生成在后续第一性原理计算中可读的pwmat格式结构文件。
    `,
    feature4: `
    Q-Studio功能目前正处在快速迭代期，构造表面结构、建立真空层、建立吸附体系、数据库结构导入、绘制分子等新功能将在近期上线。
    `,
    step1: '通过龙讯超算云平台访问Q-Studio',
    step2: '建立晶格',
    step3: '修改晶格',
    step4: '添加原子',
    step5: '建立超胞',
    step6: '移动原子',
    step7: '修改元素',
    step8: '固定原子',
    step9: '建立群组',

    download: '相关下载',
    download1: 'PWmat下载',
    download2: 'Module下载',
    download3: '手册下载',
    download4: '赝势下载',
    download5: 'Mcloud手册',
  }
}